@if (machine(); as m) {
  <p class="back"><a routerLink="/machines">← Macchinari</a></p>
  <header class="page-header">
    <div>
      <h1>{{ m.name }}</h1>
      <p>{{ m.manufacturer }} {{ m.model }} · {{ m.location || 'Senza ubicazione' }}</p>
    </div>
  </header>

  @if (message()) {
    <p class="flash">{{ message() }}</p>
  }

  <div class="grid">
    <section>
      <h2>Etichetta QR</h2>
      <div class="qr-box">
        @if (qrDataUrl()) {
          <img [src]="qrDataUrl()" [alt]="'QR ' + m.name" />
        }
        <code>{{ m.qr_token }}</code>
        <p class="hint">La PWA legge questo token dallo scan.</p>
      </div>
    </section>

    <section>
      <h2>Documenti / Manuali PDF</h2>
      <label class="file-btn">
        Carica PDF
        <input type="file" accept="application/pdf" (change)="onFileSelected($event)" hidden />
      </label>
      <ul class="list">
        @for (d of documents(); track d.id) {
          <li>
            <span>{{ d.filename }}</span>
            <button type="button" (click)="startExtraction(d.id)">Estrai con AI</button>
          </li>
        } @empty {
          <li class="muted">Nessun documento</li>
        }
      </ul>
    </section>

    <section>
      <h2>Piani manutenzione</h2>
      <form class="inline-form" (ngSubmit)="createPlan()">
        <input [(ngModel)]="planForm.title" name="title" placeholder="Titolo" required />
        <input type="number" [(ngModel)]="planForm.frequency_value" name="freq" min="1" />
        <select [(ngModel)]="planForm.frequency_unit" name="unit">
          <option value="days">giorni</option>
          <option value="weeks">settimane</option>
          <option value="months">mesi</option>
          <option value="years">anni</option>
          <option value="hours">ore</option>
        </select>
        <textarea [(ngModel)]="planForm.instructions" name="instructions" placeholder="Istruzioni" rows="2"></textarea>
        <button type="submit">Aggiungi piano</button>
      </form>
      <ul class="list">
        @for (p of plans(); track p.id) {
          <li>
            <strong>{{ p.title }}</strong>
            <span>ogni {{ p.frequency_value }} {{ p.frequency_unit }} · {{ p.is_approved ? 'approvato' : 'bozza' }}</span>
          </li>
        }
      </ul>
    </section>

    <section>
      <h2>Interventi</h2>
      <ul class="list">
        @for (t of tasks(); track t.id) {
          <li>
            <strong>{{ t.title }}</strong>
            <span class="status" [attr.data-status]="t.status">{{ t.status }}</span>
            <span>{{ t.due_at ? (t.due_at | date: 'shortDate') : '—' }}</span>
          </li>
        } @empty {
          <li class="muted">Nessun intervento</li>
        }
      </ul>
    </section>
  </div>
}
